import { render, staticRenderFns } from "./JianchaSetting.vue?vue&type=template&id=734d7f76&"
import script from "./JianchaSetting.vue?vue&type=script&lang=js&"
export * from "./JianchaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JianchaSetting.vue"
export default component.exports